import { Helpers } from '../../helpers';
import { IDesignedRate } from '../../interfaces/idesigned-rate';
import { ProjectCompletionsParameter } from '../project-completions-parameter';

export class DesignedRateBase {
  DesignedRateId: number;
  Name: string | null;
  Rate: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectCompletionsParameters_DesignedRate?: Array<ProjectCompletionsParameter> | null;

  constructor(item?: IDesignedRate) {
    if (item) {

      this.DesignedRateId = item.DesignedRateId;
      this.Name = item.Name;
      this.Rate = item.Rate;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectCompletionsParameters_DesignedRate = Helpers.createClassArray(ProjectCompletionsParameter, item.ProjectCompletionsParameters_DesignedRate);
    }
  }
}